jQuery(document).ready(function($) {

    var hash = window.location.hash.substring(1, window.location.hash.length);

    if (window.location.hash) {
        setTimeout(function () {
            if ($('.variation-button').length > 0) {
                $('.variations-button').trigger('click');
                $('.variation-button[data-id*=' + hash + ']').trigger('click');

                setTimeout(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.variation-button[data-id*=' + hash + ']').offset().top - 97
                    }, 300);

                }, 300);
            }
        }, 300);
    }

    function checkElementAboveScreen() {
        var element = $('.product-scroll-element');
        var product = $('.sticky-product');
        var elementOffset = element.offset().top;
        var scrollTop = $(window).scrollTop();

        if (elementOffset < scrollTop) {
            product.removeClass('max-h-0').addClass('max-h-[97px]');
        } else {
            product.addClass('max-h-0').removeClass('max-h-[97px]');
        }
    }

    checkElementAboveScreen();

    $(window).on('scroll', function() {
        checkElementAboveScreen();
    });

});